import React from "react";
import { useTable } from "../../Components/useTable";

const Merchand = () => {
  const type = "Merchants";
  const headCells = [
    { id: "name", numeric: false, label: "name" },
    { id: "country", numeric: false, label: "country" },
    { id: "picture", numeric: false, label: "picture" },
    { id: "email", numeric: false, label: "email" },
    { id: "phone", numeric: false, label: "phone" },
    { id: "user_name", numeric: false, label: "user_name" },
    { id: "bank_name", numeric: false, label: "bank_name" },
    { id: "bank_account_number", numeric: false, label: "bank_acc_No" },
    { id: "address", numeric: false, label: "address" },
    { id: "rid", numeric: false, label: "rid" },
    { id: "code", numeric: false, label: "code" },
    { id: "level", numeric: false, label: "level" },
    { id: "view", numeric: false, label: "view" },
    { id: "whatsapp", numeric: false, label: "whatsapp" },
    { id: "dropdown1", numeric: false, label: "status" },
    { id: "userId", numeric: false, label: "userId" },
    { id: "cryptoWallet", numeric: false, label: "cryptoWallet" },
    { id: "created", numeric: false, label: "created at" },
    { id: "action", numeric: false, label: "action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default Merchand;
